import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { getRunningVersion, fetchLatestVersion, reloadWithFreshAssets } from '../utils/appUpdate';

const AppVersionFooter = () => {
    const [busy, setBusy] = useState(false);
    const running = getRunningVersion();

    const handleUpdate = async () => {
        setBusy(true);
        try {
            let latest = null;
            try {
                latest = await fetchLatestVersion();
            } catch (e) {
                latest = null;
            }

            if (latest && running && latest === running) {
                const result = await Swal.fire({
                    icon: 'success',
                    title: 'App aggiornata',
                    text: `Stai usando l'ultima versione (${running}).`,
                    showCancelButton: true,
                    confirmButtonText: 'Ricarica comunque',
                    cancelButtonText: 'OK',
                    confirmButtonColor: '#cd212a'
                });
                if (result.isConfirmed) await reloadWithFreshAssets();
            } else {
                await reloadWithFreshAssets();
            }
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="mt-10 mb-4 text-center text-xs text-gray-400">
            <span>Versione {running || 'sviluppo'}</span>
            <span className="mx-2">·</span>
            <button
                type="button"
                onClick={handleUpdate}
                disabled={busy}
                className="underline underline-offset-2 hover:text-gray-600 disabled:opacity-60"
            >
                {busy ? 'Controllo...' : 'Aggiorna app'}
            </button>
        </div>
    );
};

export default AppVersionFooter;
